import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AwesomeTooltipV2Component } from './awesome-tooltip-v2.component';
import { AwesomeTooltipV2Directive } from './awesome-tooltip-v2.directive';
import { StatusesInfoTooltipV2Directive } from './statuses-info-tooltip-v2.directive';

@NgModule({
  declarations: [AwesomeTooltipV2Component, AwesomeTooltipV2Directive, StatusesInfoTooltipV2Directive],
  imports: [CommonModule],
  exports: [AwesomeTooltipV2Component, AwesomeTooltipV2Directive, StatusesInfoTooltipV2Directive],
})
export class AwesomeTooltipV2Module {}
